import React, { useState, Fragment } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    CustomInput,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import Validation from '../../../../../../components/Validation';

export default function DefaultNotification({
    contacts,
    visible,
    toggle,
    saveContact
}) {
    const [inputFields, setInputFields] = useState(
        contacts.length > 0
            ? contacts
            : [
                {
                    name: '',
                    email: '',
                    phoneNumber: '',
                    isBcc: false,
                },
            ]
    );
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);

    const handleAddFields = () => {
        const values = [...inputFields];
        values.push({
            name: '',
            email: '',
            phoneNumber: '',
            isBcc: false,
        });
        setInputFields(values);
    };

    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
    };

    const handleInputChange = (index, event) => {
        const values = [...inputFields];
        if (event.target.name === 'name') {
            values[index].name = event.target.value;
        } else if (event.target.name === 'email') {
            values[index].email = event.target.value;
        } else if (event.target.name === 'phoneNumber') {
            values[index].phoneNumber = event.target.value;
        }
        setInputFields(values);
    };

    const handleCheckChange = (index, e) => {
        const values = [...inputFields];
        if (e.target.checked) {
            values[index].isBcc = true;
        } else {
            values[index].isBcc = false;
        }
        setInputFields(values);
    };
    const handleSubmit = (e) => {
        toggle();
        saveContact(inputFields);
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>Contacts</ModalHeader>
                <ModalBody>
                    <Row className="mb-2">
                        {inputFields.map((contact, index) => (
                            <Fragment key={index}>
                                <Colxx sm={3} className="mb-3">
                                    <Label>Name</Label>
                                    <Input
                                        type="text"
                                        name="name"
                                        value={contact.name}
                                        onChange={(event) => handleInputChange(index, event)}
                                    />
                                </Colxx>
                                <Colxx sm={3} className="mb-3">
                                    <Label>Email</Label>
                                    <Input
                                        type="text"
                                        name="email"
                                        min={1}
                                        value={contact.email}
                                        onChange={(event) => handleInputChange(index, event)}
                                    />
                                </Colxx>
                                <Colxx sm={3} className="mb-3">
                                    <Label>Phone Number</Label>
                                    <Input
                                        type="text"
                                        name="phoneNumber"
                                        min={1}
                                        value={contact.phoneNumber}
                                        onChange={(event) => handleInputChange(index, event)}
                                    />
                                </Colxx>
                                <Colxx sm={1} className="mb-3">
                                    <Label>BCC</Label>
                                    <CustomInput
                                        type="checkbox"
                                        id="bcc"
                                        checked={contact.isBcc}
                                        name="isBcc"
                                        onChange={(e) => handleCheckChange(index, e)}
                                    />
                                </Colxx>

                                <Colxx sm={2} className="mb-3">
                                    <Label>Remove</Label>
                                    <div>
                                        <Button
                                            onClick={() => handleRemoveFields(index)}
                                            color="secondary"
                                            size="xs"
                                            outline
                                            style={{ margin: '6px' }}
                                        >
                                            -
                                        </Button>
                                    </div>
                                </Colxx>
                            </Fragment>
                        ))}
                    </Row>
                    <Row className="mb-2">
                        <Colxx sm={12}>
                            <Button
                                onClick={handleAddFields}
                                color="primary"
                                size="xs"
                                outline
                                style={{ margin: '6px' }}
                            >
                                + Add Contact
                            </Button>
                        </Colxx>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary"
                        outline
                        style={{ float: 'right' }}
                        onClick={handleSubmit}
                    >
                        Save Contacts
                    </Button>
                </ModalFooter>
                <Validation
                    open={open}
                    messages={msg}
                    toggle={() => {
                        setOpen(!open);
                    }}
                ></Validation>
            </Modal>
        </Fragment>
    );
}
